const downloadExcelFile = (url) => {
  createDownloadLink(url).click()
  setTimeout(function () {
    removeDownloadLink(url)
  }, 100)
}

const createDownloadLink = (url) => {
  const link = document.createElement('a')
  link.style = 'display: none'
  link.href = url

  return link
}

const removeDownloadLink = (url) => {
  window.URL.revokeObjectURL(url)
}

export default downloadExcelFile
